import { useState } from "react";
import { FiAlertCircle } from "react-icons/fi";
import { useLocation } from "react-router";
import ProductInfoCards from "./../components/product/productdetail/ProductInfoCards";
import RelatedProducts from "./../components/product/productdetail/RelatedProducts";
import RelatedCollaborators from "./../components/professionals/professionaldetail/RelatedCollaborators";
import { IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import ScamAlertRequestModal from "../components/suspense/ScamAlertRequestModal";
import LikeComponent from "../components/suspense/LikeComponent";

const ProductDetailPage = () => {
  const location = useLocation();
  const { userDetails } = location.state;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      setOpen(true);
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <div className="transform duration-200 easy-in-out">
        <div className=" h-52 overflow-hidden bg-gray-300">
          <nav
            className="flex justify-center text-gray-900 font-semibold uppercase pt-20"
            aria-label="Breadcrumb"
          >
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <li aria-current="page">
                <div className="flex items-center">
                  <Link
                    to="/"
                    className="ms-1 text-md md:ms-2 dark:text-gray-400"
                  >
                    Home
                  </Link>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <IoIosArrowForward />
                  <Link
                    to="/product-profile"
                    className="ms-1 text-md md:ms-2 dark:text-gray-400"
                  >
                    Products
                  </Link>
                </div>
              </li>
              <li aria-current="page">
                <div className="flex items-center">
                  <IoIosArrowForward />
                  <Link className="ms-1 text-md md:ms-2 dark:text-gray-400">
                    {userDetails.Name}
                  </Link>
                </div>
              </li>
            </ol>
          </nav>
        </div>
        <div className="flex justify-center px-5 -mt-12">
          <img
            className="h-44 w-44 bg-white p-2 rounded-full"
            src={userDetails?.ProfilePicture}
            alt=""
          />
        </div>

        <div className="px-14 py-10">
          <div className="flex items-center justify-center">
            <div className="text-2xl border-r border-gray-400 pr-4">
              {userDetails?.Name}
            </div>
            <div className="flex items-center gap-4 text-gray-500 text-lg cursor-pointer font-semibold pl-4">
              <LikeComponent userDetails={userDetails} />
              <FiAlertCircle className="cursor-pointer" onClick={handleClick} />
            </div>
          </div>
        </div>

        <div className="lg:px-40 flex mb-10 justify-center">
          <span>{userDetails?.ShortBio}</span>
        </div>

        <ProductInfoCards />
        <RelatedProducts userDetails={userDetails} />
        <RelatedCollaborators userId={userDetails.UserId}/>
      </div>
      <ScamAlertRequestModal
        open={open}
        setOpen={setOpen}
        userDetails={userDetails}
      />
    </>
  );
};

export default ProductDetailPage;
